import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { AudienceSection } from '../components/AudienceSection';
import { TransformationSection } from '../components/TransformationSection';
import { FAQSection } from '../components/FAQSection';
import { PreCloseSection } from '../components/PreCloseSection';
import { OfferSection } from '../components/OfferSection';
import { LegalFooter } from '../components/LegalFooter';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
    __fbPixelReady: boolean;
  }
}
export function LandingPage() {
  return <main className="min-h-screen bg-white font-sans text-[#2D1F0E]" data-id="element-208">
      <HeroSection data-id="element-209" />
      <ProblemSection data-id="element-210" />
      <MechanismSection data-id="element-211" />
      <WhatYouGetSection data-id="element-212" />
      <AudienceSection data-id="element-213" />
      <TransformationSection data-id="element-214" />
      <FAQSection data-id="element-215" />
      <PreCloseSection data-id="element-216" />
      <OfferSection data-id="element-217" />
      <LegalFooter data-id="element-218" />
    </main>;
}